import { useRef } from "react";

import ConfirmationPopover from "@/appComponents/Blocks/Composites/ConfirmationPopover/ConfirmationPopover";
import { appstr } from "@coreapp/utils/appstr";
import { Text, Tooltip } from "@theorgchartdev/storybook";

interface DeleteBoxStylePopoverProps {
  onConfirmDelete: () => Promise<void>;
  triggerTestId?: string;
  dataTestPrefix?: string;
}

export const DeleteBoxStylePopover = ({
  onConfirmDelete,
  triggerTestId,
  dataTestPrefix
}: DeleteBoxStylePopoverProps) => {
  const openCtrlRef = useRef(null);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    e.stopPropagation();
  };

  return (
    <div onClick={handleClick} onKeyDown={handleKeyDown}>
      <Tooltip message={appstr("Delete box style")} referenceOpenCtrlRef={openCtrlRef}>
        <ConfirmationPopover
          openCtrlRef={openCtrlRef}
          onSubmit={onConfirmDelete}
          icon={"trash-can"}
          iconOnly
          triggerTestId={triggerTestId}
          dataTestPrefix={dataTestPrefix}
          iconProps={{
            size: "small"
          }}
          color="error"
          otherHeaderProps={{ title: appstr("Delete box style?") }}
          confirmLabel={appstr("Delete")}
        >
          <Text>{appstr("Delete box style confirmation")}</Text>
        </ConfirmationPopover>
      </Tooltip>
    </div>
  );
};
